import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
  useQuery,
  UseQueryOptions,
  UseQueryResult,
  useQueryClient,
} from "@tanstack/react-query";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { TResponse } from "../../../types/common";
import { detail, saveHomePage } from "./callbacks";
import { IHomePagePayload } from "@src/types/api/homepage";

export const  useHomePageSave = (
  {
    onSuccess,
    onError,
  }: {
    onSuccess?: (res: TResponse<IHomePagePayload>) => void;
    onError?: (error: unknown) => void;
  },
  options: UseMutationOptions<
    TResponse<IHomePagePayload>,
    unknown,
    IHomePagePayload
  > = {}
): UseMutationResult<TResponse<IHomePagePayload>, unknown, IHomePagePayload> => {
  const queryClient = useQueryClient();

  return useMutation<TResponse<IHomePagePayload>, unknown, IHomePagePayload>({
    mutationFn: async (data: IHomePagePayload) => {
      const response = await saveHomePage(data);
      return response.data;
    },
    onSuccess: (res, ...rest) => {
      if (res.data) {
        queryClient.invalidateQueries({
          queryKey: [API_ENDPOINTS.HOMEPAGE_DETAIL],
        });
      }

      onSuccess?.(res);
      options?.onSuccess?.(res, ...rest);
    },
    onError: (error, ...rest) => {
      onError?.(error);
      options?.onError?.(error, ...rest);
    },
    ...options,
  });
};

export const useHomePageDetail = (
): UseQueryResult<TResponse<IHomePagePayload>, Error> => {
  return useQuery<TResponse<IHomePagePayload>, Error>({
    queryKey: [API_ENDPOINTS.HOMEPAGE_DETAIL],
    queryFn: async () => {
      const res = await detail();
      return res.data;
    },
    refetchOnWindowFocus: false,
    staleTime: 300000,
  });
};
